import { NAMESPACE } from './constants';

export const SHOW_LOADER = `${NAMESPACE}/SHOW_LOADER`;
export const ATTACH_FILE = `${NAMESPACE}/ATTACH_FILE`;
export const SELECT_FILE = `${NAMESPACE}/SELECT_FILE`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
